import React, { useEffect, useState } from 'react';
import { View, StyleSheet, Image, TouchableOpacity, Text } from 'react-native';
import Config from 'react-native-config';
import { CometChatUIKit } from '../../libraries/ReactNativeCometChatUiKit';
import { isAndroid, isBlank, isIOS, isPresent, isWeb } from '../../utils/BooleanUtility';
import colors from '../../theme/Colors';
import { TabNavigationLeftHeader, TabNavigationRightHeader } from '../../components/header';
import { LISTS_API_VERSION, TABBAR_CONSTANT, API_DOMAIN, NOTIFICATION_REQUEST_MODAL_TYPE, cometChatCredentials, FOXY_URLS } from '../../config/Constants';
import images from '../../theme/Images';
import Utility from '../../utils/Utility';
import ChatHeader from './ChatHeader';
import { useFocusEffect, useNavigation } from '@react-navigation/native';
import { memoize } from 'lodash';
import { convertJsonFromResponse, getApiHeaders, getRequestHeader } from '../../sagas/GeneratorUtil';
import { List } from '../List';
import { useDispatch } from 'react-redux';
import { setCometChatUserData, updateUnreadChatCount } from '../../actions/ActionTypes';
import { getStoreRef } from '../../store/StoreUtility';
import PermissionsUtility, { getIOSNotificationPermission } from '../../utils/PermissionsUtility';
import { SCREEN_CONSTANTS } from '../../config/ScreenConstants';
import { messaging } from '../../libraries/Firebase';
import CometChat from '../../libraries/ReactNativeCometChatSdk';
import CometChatNotifications from '../../libraries/ReactNativeCometChatNotifications';
import FastImageView from '../../components/FastImageView';
import ChatTabIcon from './ChatTabIcon';
import { AnalyticsManager, EventParameterKey, EventParameterValue, EventType } from '../../analytics';

//TODO: revert this change currently doing to review this app
const Chat = () => {
  const [data, setData] = useState({});
  const [userData, setUserData] = useState({});
  const [isAppInstallPromptVisible, setAppInstallPromptVisible] = useState(false);
  const dispatch = useDispatch();
  const state = getStoreRef().getState();
  const navigation = useNavigation();
  const store = getStoreRef().getState();
  const authToken = store.UserAccountInfo.authToken;
  const subscribedRoutines = store?.UserAccountInfo?.subscribedRoutines;

  useEffect(() => {
    const { data: { attributes: { uid = '' } = {} } = {} } = userData;
    if (isWeb()) return;
    CometChatUIKit.login({ uid })
      .then((user) => {
        registerPushTokenAPI(user.authToken);
        console.tron.log('User logged in successfully  (user.getName())');
      })
      .catch((error) => {
        console.tron.log('Login failed with exception:', error);
      });
  }, [userData]);

  const registerPushTokenAPI = async (authToken) => {
    const { cometChatAppID, cometChatAuthKey } = cometChatCredentials;
    try {
      const apnsToken = (await messaging().getAPNSToken()) || '';
      const fcmToken = (await messaging().getToken()) || '';
      const body = {
        authToken,
        timezone: 'Asia/Kolkata',
      };
      if (isIOS()) {
        body.platform = 'apns_react_native_device';
        body.deviceToken = apnsToken;
        body.providerId = Config.IOS_PROVIDER_ID;
      } else {
        body.platform = 'fcm_react_native_android';
        body.fcmToken = fcmToken;
        body.providerId = Config.ANDROID_PROVIDER_ID;
      }
      const response = await fetch(`https://${cometChatAppID}.api-in.cometchat.io/v3/notifications/push/v1/tokens`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          apiKey: cometChatAuthKey,
        },
        body: JSON.stringify(body),
      });
    } catch (e) {
      console.tron.log(`${e}`, '------');
    }
  };

  useEffect(() => {
    // Add focus and blur listeners
    const focusListener = navigation.addListener('focus', () => {
      fetchChatDetails();
      fetchCometChatUser();
      displayNotificationRequestModal();
      if (isAndroid()) {
        Utility.setStatusBarColor(colors.background);
      }
      if (isWeb()) return;
      getChatCount();
    });

    // Cleanup listeners on unmount
    return () => {
      focusListener();
    };
  }, []);

  useEffect(() => {
    if (isWeb()) return;
    getChatCount();
  }, [data]);

  const getChatCount = async () => {
    const getDeliveredNotification = await CometChat.getUnreadMessageCountForAllGroups(true);
    let totalUnreadCount = 0;
    if (isPresent(getDeliveredNotification)) {
      totalUnreadCount = _.reduce(
        Object.values(getDeliveredNotification) || [],
        (total, item) => {
          return total + item;
        },
        0,
      );
    }
    dispatch(updateUnreadChatCount(totalUnreadCount));
  };

  useEffect(() => {
    // Add focus and blur listeners
    const focusListener = navigation.addListener('focus',()=>{
      AnalyticsManager.setCurrentScreen(EventParameterValue.SCREEN_NAME.CHAT)
      AnalyticsManager.logEvent(EventType.discoveryEvents.TAB_VIEW,{
        [EventParameterKey.TAB]: EventParameterValue.SCREEN_NAME.CHAT
      })
    })

    const blurListener = navigation.addListener('blur', () => {
      Utility.setStatusBarColor(colors.background);
    });

    // Cleanup listeners on unmount
    return () => {
      blurListener();
      focusListener();
    };
  }, []);

  const displayNotificationRequestModal = () => {
    const lastNotificationModalDisplayTime = state.UserAccountInfo.lastNotificationModalDisplayTime;
    const initial_app_opened_at = state.UserAccountInfo.initial_app_opened_at;
    if (isIOS()) {
      getIOSNotificationPermission('', (permission) => {
        if (permission !== 'NotificationAuthorized') {
          showNotificationModal(true)
        }
      });
      return;
    }

    if (!PermissionsUtility.shouldShowNotificationModalForCurrentSession(SCREEN_CONSTANTS.ROUTINES_PAGE)) {
      return;
    }

    Utility.canDisplayNotificationRequestModal(
      lastNotificationModalDisplayTime,
      'routine',
      (canDisplay, showNotificationPrompt) => {
        if (canDisplay) {
          showNotificationModal(true, showNotificationPrompt);
          PermissionsUtility.setNotificationModalVisibilityForCurrentSession(SCREEN_CONSTANTS.ROUTINES_PAGE, true);
        }
      },
      initial_app_opened_at,
      true,
    );
  };

  const showNotificationModal = (show, showNotification) => {
    navigation.push('NotificationModal', {
      showNotificationPrompt: showNotification,
      type: NOTIFICATION_REQUEST_MODAL_TYPE.ROUTINES,
    });
  };

  const fetchChatDetails = async () => {
    const url = `${API_DOMAIN}/api/${LISTS_API_VERSION}/lists/comet-chats`;
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: getRequestHeader(),
      });

      if (response.ok) {
        // response.ok is shorthand for status >= 200 && status < 300
        const json = await response.json();

        if (!Utility.isBlank(json)) {
          setData(json); // Assuming setData updates the state
        } else {
          console.tron.log('Response JSON is blank');
        }
      } else {
        console.tron.log(`Error: HTTP ${response.status}`, response);
        // Optionally: Show an error message to the user
      }
    } catch (error) {
      console.tron.log(error, 'Fetch Error');
      // Optionally: Display error feedback to the user or retry logic
    }
  };

  const fetchCometChatUser = async () => {
    const url = `${API_DOMAIN}/api/v1/comet_chat_users`;
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: getRequestHeader(),
      });

      if (response.ok) {
        // response.ok is shorthand for status >= 200 && status < 300
        const json = await response.json();

        if (!Utility.isBlank(json)) {
          setUserData(json); // Assuming setData updates the state
          dispatch(setCometChatUserData(json));
        } else {
          console.tron.log('Response JSON is blank');
        }
      } else {
        console.tron.log(`Error: HTTP ${response.status}`, response);
        // Optionally: Show an error message to the user
      }
    } catch (error) {
      console.tron.log(error, 'Fetch Error');
      // Optionally: Display error feedback to the user or retry logic
    }
  };

  return (
    <View style={styles.containerWithoutHeader}>
      <ChatHeader />
      <List itemData={data} key={`${authToken}`} previousScreen={'Chat'} />
    </View>
  );
};

export default Chat;

const styles = StyleSheet.create({
  tabImageStyle: {
    height: 24,
    width: 24,
    resizeMode: 'contain',
  },
  toastStyle: {
    position: 'absolute',
    bottom: 100,
  },
  container: {
    flex: 1,
    backgroundColor: colors.background,
  },
  containerWithoutHeader: {
    flex: 1,
    backgroundColor: colors.background,
    paddingTop: isIOS() ? 50 : 0,
  },
  listItemStyle: {
    backgroundColor: colors.hiper_chat_container,
    marginBottom: 12,
    marginHorizontal: -6,
    borderRadius: 8,
    flexDirection: 'row',
    padding: 12,
    height: 75,
  },
  conversationIcon: {
    height: 56,
    width: 56,
    borderRadius: 30,
    borderWidth: 1,
    borderColor: colors.subtitle,
    marginRight: 12,
  },
  flexContainer: {
    flex: 1,
  },
  conversationTitle: {
    fontFamily: 'Roboto-Bold',
    fontSize: 14,
    color: colors.black,
  },
  conversationSubtitle: {
    fontFamily: 'Roboto-Medium',
    fontSize: 12,
    color: colors.black,
  },
  conversationBody: {
    fontFamily: 'Roboto-Medium',
    fontSize: 12,
    color: colors.black,
  },
  conversationLastMessageSender: {
    fontFamily: 'Roboto-Medium',
    fontSize: 12,
    color: colors.subtitle,
  },
  conversationLastMessage: {
    fontFamily: 'Roboto-Regular',
    fontSize: 12,
    color: colors.subtitle,
  },
  liveIndicatorContainer: {
    borderRadius: 4,
    borderWidth: 1,
    borderColor: colors.foxyRed,
    padding: 1,
    paddingHorizontal: 4,
    alignSelf: 'center',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  liveIndicator: {
    height: 4,
    width: 4,
    borderRadius: 2,
    marginRight: 2,
    backgroundColor: colors.foxyRed,
  },
  liveIndicatorText: {
    fontFamily: 'Roboto-Medium',
    color: colors.foxyRed,
    fontSize: 8,
  },
  indicatorContainer: {
    height: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  unreadMessagesCountContainer: {
    backgroundColor: '#1B1F6A',
    borderRadius: 12,
    paddingHorizontal: 6,
    paddingVertical: 2,
    position: 'absolute',
    right: 4,
    top: 4,
  },
  unreadMessagesCountText: {
    color: colors.white,
    fontSize: 10,
    fontFamily: 'Roboto-Medium',
  },
});

export const ChatNavigationOptions = {
  headerShown: false,
  title: 'Rx Chat',
  headerTitleAlign: 'center',
  headerTitleStyle: {
    textAlign: 'center',
    alignSelf: 'center',
    fontSize: 15,
    fontFamily: 'Roboto-Medium',
  },
  headerLeft: () => <TabNavigationLeftHeader tabBar={TABBAR_CONSTANT.category} />,
  headerRight: () => <TabNavigationRightHeader showCart store tabBar={TABBAR_CONSTANT.category} />,
  headerTitle: () => (
    <Image
      source={Utility.isPresent(Config.HEADER_LOGO) ? { uri: Config.HEADER_LOGO } : images.foxy_header_image}
      style={{
        height: parseInt(Config.HEADER_LOGO_HEIGHT),
        width: parseInt(Config.HEADER_LOGO_WIDTH),
        resizeMode: 'cover',
      }}
    />
  ),
  headerBackVisible: false,
  headerShadowVisible: false,
  headerStyle: {
    backgroundColor: colors.white,
  },
  tabBarLabel: Config.CHAT_TAB_LABEL,
  tabBarActiveTintColor: Config.CHAT_TAB_ACTIVE_TEXT_COLOR ?? Config.CHAT_TAB_ACTIVE_COLOR,
  tabBarInactiveTintColor: Config.CHAT_TAB_INACTIVE_COLOR,
  tabBarStyle: { borderTopWidth: 0, elevation: 0 },
  tabBarIcon: ({ focused }) => {
    const focusedIcon = { uri: Config.CHAT_TAB_ACTIVE_ICON_URL };

    const unfocusedIcon = { uri: Config.CHAT_TAB_ICON_URL };
    const icon = focused ? focusedIcon : unfocusedIcon;
    const tintColor = focused ? (isWeb() ? '' : Config.CHAT_TAB_ACTIVE_COLOR) : Config.CHAT_TAB_INACTIVE_COLOR;

    const imageStyle = getMemoizedImageStyle(tintColor);
    return (
      <>
        <ChatTabIcon icon={icon} imageStyle={imageStyle} />
      </>
    );
  },
  tabBarOnPress: ({ navigation, defaultHandler }) => {
    defaultHandler();
    const { state: { routes = [] } = {} } = navigation;
    if (!navigation.isFocused()) return;
    if (isPresent(routes)) {
      const route = routes[0];
      const { params: { scrollToTop = () => {} } = {} } = route;
      scrollToTop();
    }
  },
};

const chatContainerStyle = ChatNavigationOptions.headerShown ? styles.container : styles.containerWithoutHeader;

const imageStyles = {};

const getMemoizedImageStyle = (tintColor) => {
  if (!imageStyles[tintColor]) {
    imageStyles[tintColor] = [styles.tabImageStyle, { tintColor }];
  }
  return imageStyles[tintColor];
};
